import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useForgotPasswordAuthCheck } from "../../api/effects/mutations/ForgotPassword/forgotPasswordAuthCheck";
import LoadingScreen from "../../components/LoadingScreen";
import ForgotPasswordChangePage from "./ForgotPasswordChangePage";
import ForgotPasswordPage from "./ForgotPasswordPage";

type Props = {};

export default function ForgotPasswordLayout({}: Props) {
  const { token } = useParams();

  const [authValue, setAuthValue] = useState(false);

  const { mutateAsync: check, isLoading } = useForgotPasswordAuthCheck({
    onSuccess() {
      setAuthValue(true);
    },
    onError() {
      setAuthValue(false);
    },
  });

  useEffect(() => {
    if (token) {
      check({ token: token });
    }
  }, []);

  if (isLoading) {
    return <LoadingScreen open={isLoading} />;
  }

  return authValue ? <ForgotPasswordChangePage /> : <ForgotPasswordPage />;
}
